import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/common/components/dialog';
import { Button } from '@/components/ui/button';

export interface PromptDeleteActionProps {
  handleClose: (shouldDelete?: boolean) => void;
  open?: boolean;
  title: string;
}

function PromptDeleteAction({
  handleClose,
  open,
  title,
}: PromptDeleteActionProps) {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      handleClose(false);
    }
  };

  function cancelDelete() {
    handleClose(false);
  }

  function handleDelete() {
    handleClose(true);
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogFooter className="flex flex-row justify-end gap-2 mt-4">
          <Button variant="outline" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button
            data-testid="confirm-delete-board-button"
            variant="destructive"
            onClick={handleDelete}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PromptDeleteAction;
